import { AnyAction } from 'redux'
import actionTypes from '../actions/actionTypes'

export interface IQSStore {
	jwt: string
	gameSessionUid: string
}

const defaultState = {
	jwt: '',
	gameSessionUid: '',
}

function initializeApp(state: IQSStore, action: AnyAction): IQSStore {
	return {
		...state,
		...action.params,
	}
}

function qsReducer(state: IQSStore = defaultState, action: AnyAction): IQSStore {
	switch (action.type) {
		case actionTypes.APP_INIT:
			return initializeApp(state, action)
		default:
			return state
	}
}

export default qsReducer
